<script>
  
</script>

<!-- svelte-ignore a11y-invalid-attribute -->
<div class="row mt-2 border-bottom pb-1 ">
  <div class="d-flex justify-content-between align-middle flex-wrap">

    <small class='pb-0 lh-1 align-self-center'>
      <slot name="title"/>
    </small>
    
    <div class="pb-0 lh-1 align-self-end mt-2 mt-md-0">
      <slot name="toolbar"/>
    </div>
  </div>
</div>


